import * as yup from 'yup';

const REQUIRED_MESSAGE = 'Обязательное поле';

const stringField = yup.string().typeError(REQUIRED_MESSAGE).trim().required(REQUIRED_MESSAGE);
const dateField = yup.number().typeError(REQUIRED_MESSAGE).required(REQUIRED_MESSAGE);

export const ORDER_MANUAL_CREATE_SCHEMA = yup.object({
  direction: stringField,
  status: stringField,
  amount: stringField.test(
    'positive',
    'Сумма должна быть больше 0',
    (value) => Number(value?.replace(',', '.')) > 0,
  ),
  createdAt: dateField,
  updatedAt: dateField.test(
    'not-before-created',
    'Время исполнения не может быть раньше времени создания',
    function (value) {
      const { createdAt } = this.parent;

      return !value || !createdAt || value >= createdAt;
    },
  ),
  merchantReferenceId: stringField,
  providerReferenceId: stringField,
  customerId: stringField,
  customerAccount: stringField,
  merchant: stringField,
  merchantAccount: stringField,
  provider: stringField,
  gateway: stringField,
  method: stringField,
  currencyId: stringField,
  countryId: stringField,
  merchantName: yup.string().default(''),
  merchantAccountName: yup.string().default(''),
  providerName: yup.string().default(''),
  gatewayName: yup.string().default(''),
  methodName: yup.string().default(''),
  currency: yup.string().default(''),
  country: yup.string().default(''),
});
